import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ReactComponent as BillingAmexCard } from './assets/CardAMEX.svg';
import { ReactComponent as BillingDiscoverCard } from './assets/CardDISCOVER.svg';
import { ReactComponent as BillingMastercardCard } from './assets/CardMASTERCARD.svg';
import { ReactComponent as BillingTestCard } from './assets/CardTESTCARD.svg';
import { ReactComponent as BillingVisaCard } from './assets/CardVISA.svg';

const StyledContainer = styled.div`
  box-sizing: border-box;
`;

const CardIcon = ({ cardType }) => {
  let icon = null;

  switch (cardType) {
    case 'testcard':
    case 'TESTCARD':
      icon = <BillingTestCard />;
      break;
    case 'amex':
      icon = <BillingAmexCard />;
      break;
    case 'discover':
      icon = <BillingDiscoverCard />;
      break;
    case 'mastercard':
      icon = <BillingMastercardCard />;
      break;
    case 'visa':
      icon = <BillingVisaCard />;
      break;

    default:
      return;
  }

  return <StyledContainer>{icon}</StyledContainer>;
};

CardIcon.propTypes = {
  cardType: PropTypes.string,
};

export default CardIcon;
